const stringIndex = 50
const key = "QXERTTUBHG"

const tokenEncryption = (token: string): string => {
  const base64 = window.btoa(encodeURIComponent(token))
  return base64
    .slice(0, stringIndex)
    .concat(key)
    .concat(base64.slice(stringIndex, base64.length))
}

const tokenDecryption = (token: string): string => {
  const base64 = token
    .slice(0, stringIndex)
    .concat(token.slice(stringIndex + key.length))
  return decodeURIComponent(window.atob(base64))
}

export const setTenantName = (tenantName: string) => {
  if (!tenantName) return null;
  const formattedName = tenantName.trim().replace(/\s+/g, '-');
  sessionStorage.setItem("tenantName", formattedName);
}

export const getTenantName = () => {
  const tenantName = sessionStorage.getItem("tenantName") as string
  if (!tenantName) return null
  return tenantName
}

export const setToken = (token: string) => {
  if (!token) return null
  sessionStorage.setItem("serviceToken", tokenEncryption(token))
}

export const getToken = () => {
  const token = sessionStorage.getItem("serviceToken") as string
  if (!token) return null
  return tokenDecryption(token)
}

export const removeToken = () => {
  sessionStorage.removeItem("serviceToken")
}
